
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum DnsResponseStatus {
	Ok = 0,
	NotFound = 2,
	PendingChanges = 3,
	UnknownError = 5
}
export namespace DnsResponseStatus {
	export function getKeys(): Map<DnsResponseStatus, string> {
		return new Map([[0, 'Ok'], [2, 'NotFound'], [3, 'PendingChanges'], [5, 'UnknownError']]);
	}
}
